module.exports = __webpack_public_path__ + "static/media/sologo.47438f68.png";